module.exports = __webpack_public_path__ + "img/head-shredder.d2fba911.png";